// src/utils/copyToClipboard.ts
import { toast } from "react-toastify";

export async function copyToClipboard(text: string, showToast: boolean = true) {
  try {
    await navigator.clipboard.writeText(text);

    if (showToast) {
      toast.success("Kopyalandı ✅", {
        toastId: "copy-success",
      });
    }
  } catch (err) {
    console.error("Kopyalama başarısız:", err);
    if (showToast) {
      toast.error("Kopyalanamadı ❌", {
        toastId: "copy-error",
      });
    }
  }
}
